import { useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
import debounce from "lodash/debounce";
import { useGetOffersQuery } from "@app/store/offersApi";
import Car from "@shared/lib/interfaces/car.interface";
import { CatalogDataParams } from "./types";

export const useCatalogData = ({
    filters,
    mapListMode,
    formattedCoordinates,
    newZoom,
    createdParamSort,
    createdTimePrev,
    ssrOffers,
    ssrQuantity,
    ssrTotalPages
}: CatalogDataParams) => {
    const router = useRouter();
    const currentPage = router.query.page ? parseInt(router.query.page as string) : 1;

    const [dataMemory, setDataMemory] = useState<Car[]>(ssrOffers);
    const [previewQnt, setPreviewQnt] = useState<null | number>(ssrQuantity);
    const [totalPages, setTotalPages] = useState<number>(ssrTotalPages);
    const [skip, setSkip] = useState(false);
    const [isPrevDataLoading, setIsPrevDataLoading] = useState(false);

    const { data, error, isLoading, isFetching } = useGetOffersQuery(
        {
            page: currentPage,
            ...filters,
            ...(createdParamSort && { sort: createdParamSort }),
            ...(createdTimePrev && { created_at: createdTimePrev }),
            ...(mapListMode
                ? {
                      bottom_left: formattedCoordinates.bottomLeft,
                      top_right: formattedCoordinates.topRight,
                      precision: newZoom
                  }
                : {})
        },
        {
            skip: skip
        }
    );

    const debounceSetQnt = useRef(
        debounce(async (value) => {
            setPreviewQnt(value);
        }, 150)
    ).current;

    const debounceSetIsPreviewDataLoading = useRef(
        debounce(async (value) => {
            setIsPrevDataLoading(value);
        }, 150)
    ).current;

    useEffect(() => {
        if (data && data.offers) {
            setDataMemory(data.offers);
            setTotalPages(data.meta.totalPage);
        }
    }, [data]);

    return {
        dataMemory,
        setDataMemory,
        previewQnt,
        totalPages,
        setTotalPages,
        skip,
        setSkip,
        isPrevDataLoading,
        data,
        error,
        isLoading,
        isFetching,
        currentPage,
        debounceSetQnt,
        debounceSetIsPreviewDataLoading
    };
};